import { createMask } from '@ngneat/input-mask';

// Time box used on the workout screens (HH:MM:SS.hundredths, mask 99:99:99.99).
//
// FIXED 2026-11-04. The old copies of this mask (one per screen) had an
// onBeforeMask that kept only `minutes:seconds` and dropped the hours. That
// function runs whenever a saved value is written back into the box (re-opening
// a workout to edit it, removing a set, re-rendering a list), so a correct time
// such as 0:0:5.11 reappeared as "05:11:__.__". Typing into that shifted box
// then saved a time minutes or hours off (5.11 s became 5 min 11 s), which
// pushed ACI category scores below zero.
//
// Now the value written back is always padded to the full HH:MM:SS.ss, so what
// the user sees on edit is exactly what was saved.

// "0:0:5.11" | "0:6:25" | "00:00:07.31" -> "00:00:05.11" | "00:06:25.00" | "00:00:07.31"
export function toTimeBoxValue(value: any): string {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  const parts = String(value).split(':');
  while (parts.length < 3) {
    parts.unshift('0');
  }
  const [h, m, sRaw] = parts.slice(-3);
  const [s, frac = ''] = String(sRaw).split('.');
  const pad = (x: string) => String(Number(x) || 0).padStart(2, '0');
  return `${pad(h)}:${pad(m)}:${pad(s)}.${(frac + '00').slice(0, 2)}`;
}

// Box text -> value sent to the API (H:M:S.ss, e.g. "0:0:5.11"). Same
// normalisation as before: overflowing minutes/seconds carry into the next unit.
export function fromTimeBoxValue(value: string): string {
  const hours = value.split(':')[0];
  const minutes = value.split(':')[1];
  const seconds = value.split(':')[2];
  return `${Number(hours) ? Number(hours) + parseInt((Number(minutes) / 60).toString()) : 0 + parseInt((Number(minutes) / 60).toString())}:${Number(minutes) % 60 + parseInt((Number(seconds) / 60).toString())}:${Number(seconds) % 60}`;
}

export function createTimeInputMask() {
  return createMask<string>({
    inputType: 'number',
    mask: '99:99:99.99',
    placeholder: '_',
    onBeforeMask: (value: string) => toTimeBoxValue(value),
    parser: (value: string) => fromTimeBoxValue(value),
  });
}
